import { render, staticRenderFns } from "./WizardModalPaymentMethodSettings.vue?vue&type=template&id=7170b426&scoped=true&"
import script from "./WizardModalPaymentMethodSettings.vue?vue&type=script&lang=js&"
export * from "./WizardModalPaymentMethodSettings.vue?vue&type=script&lang=js&"
import style0 from "./WizardModalPaymentMethodSettings.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./WizardModalPaymentMethodSettings.vue?vue&type=style&index=1&id=7170b426&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7170b426",
  null
  
)

export default component.exports